var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{ref:"audioPlay",class:_vm.buttonClass,attrs:{"type":"button"},on:{"click":function($event){_vm.isPlaying = !_vm.isPlaying}}},[_vm._v("재생")])])}
var staticRenderFns = []

export { render, staticRenderFns }